import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../STATE__generation';

import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';

export const remote_user_task_create = createAsyncThunkSafe<string, string>(
  ENUM__network_event_client_to_server.USER_TASK_CREATE,
  async (workspace_id, thunkApi): Promise<string> => {
    return await send_to_server<string>(ENUM__network_event_client_to_server.USER_TASK_CREATE, workspace_id);
  },
);

export function init_remote_user_task_create(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder

    .addCase(remote_user_task_create.pending, state => {})

    .addCase(remote_user_task_create.rejected, (state, action) => {})

    .addCase(remote_user_task_create.fulfilled, (state, action: PayloadAction) => {});
}
